export default __webpack_public_path__ + "static/char-v-31-f28ba4dc3d9d2b084adad48a39500d56.png";